/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { BorderOutlined, CheckSquareFilled } from '@ant-design/icons'
import type { ICellRendererParams } from 'ag-grid-community'
import { Tooltip } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'
import { MODAL_TOKENS } from 'src/styles/modalTokens'
import { useSpareConfirmState } from '../../hooks/useSpareConfirmState'
import type { AttendancePlayer } from '../../types'

interface ConfirmCheckboxProps {
  player: AttendancePlayer
}

const ConfirmCheckbox: React.FC<ConfirmCheckboxProps> = ({ player }) => {
  const {
    confirmed,
    confirmDisabled,
    canDePromote,
    confirmTooltip,
    onToggleConfirm,
    onDePromote,
  } = useSpareConfirmState(player)

  const onPress = confirmDisabled
    ? undefined
    : canDePromote
    ? onDePromote
    : onToggleConfirm

  return (
    // The tooltip says what pressing does (confirm / unconfirm / demote) or why
    // it can't; display-only boxes get none.
    <Tooltip title={confirmTooltip} zIndex={MODAL_TOKENS.Z_INDEX_TOOLTIP}>
      {confirmed ? (
        <CheckSquareFilled
          css={iconStyle(confirmDisabled)}
          style={{ color: colors.INFO_300 }}
          aria-label={confirmTooltip || undefined}
          onClick={onPress}
        />
      ) : (
        <BorderOutlined
          css={iconStyle(confirmDisabled)}
          style={{ color: colors.NEUTRAL_100 }}
          aria-label={confirmTooltip || undefined}
          onClick={onPress}
        />
      )}
    </Tooltip>
  )
}

/** CONFIRM column (Roster Spares). */
const ConfirmCell = ({ data }: ICellRendererParams<AttendancePlayer>) =>
  data ? <ConfirmCheckbox player={data} /> : null

export default ConfirmCell

const iconStyle = (disabled: boolean) => css`
  font-size: 24px;
  cursor: ${disabled ? 'default' : 'pointer'};
`
